<script>
import VehicleListingsBase from "@/components/VehicleListings/VehicleListingsBase.vue";
import axios from "axios";

export default {
  name: "VehicleListingsCustomPhrase",
  extends: VehicleListingsBase,
  skipVehicleListingsAutoFetch: true, // We handle fetching ourselves after API call
  props: {
    customPhrase: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.innerOptions = {
      include_score_field: true,
      location_search: {
        postal_code: this.$store.state.search.location.postalCode || "",
        radius: this.$store.state.search.location.radius || 100,
        include_distance_field: true
      }
    };

    // Set loading state immediately to show skeletons
    this.loading = true;

    axios
      .post(
        "https://api-v2.jumpfeed.com/network/publisher/carscience-search-chatbot-open-router",
        {
          message: this.customPhrase,
          visitor_profile: this.generateVisitorProfile()
        }
      )
      .then(response => {
        let output = response.data.data;

        this.innerFilters =
          "filters" in output.reply.search_request_object
            ? output.reply.search_request_object.filters
            : [];
        if (
          !window.localStorage.getItem("carscience-visitor-profile-scoring")
        ) {
          this.innerScoring =
            "scoring" in output.reply.search_request_object
              ? output.reply.search_request_object.scoring
              : [];
        }
        this.innerSorting =
          "sorting" in output.reply.search_request_object
            ? output.reply.search_request_object.sorting
            : [];
      })
      .catch(e => {
        console.log(e);
        this.loading = false; // Stop loading on error
      })
      .finally(() => {
        this.getVehicles(); // This will handle setting loading to false
      });
  }
};
</script>
